import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { APIService } from '../api.service';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.css'],
    standalone: false
})
export class GalleryComponent implements OnInit {
  @Output() SelectGalleryFoldersIndexEmit = new EventEmitter<string[]>();

  GalleryFolders: any;

  constructor(private APIService: APIService, private router: Router, private DataService: DataService) { }

  async ngOnInit() {
    this.GalleryFolders = await this.APIService.GetGalleryFolders();
    //console.log("GalleryComponent.ngOnInit GalleryFolders: ", this.GalleryFolders);
  }

  openPhotos(FileList: string[]) {
    //need to now open photos component and show photos for this folder
    this.DataService.updateFiles(FileList);
    this.router.navigate(['/photos']);
  }
}
